export const listApplicationAccounts = `
   query listAccountApplications($filter:AccountApplicationsFilterInput) {
       listAccountApplications(filter:$filter) {
           items {
              id
              accountId
              applicationId
              application {
                  id
                  name
              }
              accountApplicationStatus
              created
              updated
           }
           nextToken
       }
   }
`;


export const getApplicationAccount = `
   query getAccountApplication($id:ID!) {
       getAccountApplication(id:$id) {
         id
         accountId
         applicationId
         application {
             id
             name
         }
         accountApplicationStatus
         created
         updated
       }
}`;
